
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "de6c52785f4bd9fd3dad.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			